import getUnicodeFlagIcon from 'country-flag-icons/unicode';
import React from 'react';

import SearchableSelect from './searchable_select';

const sanitizeSearchInput = value => value.replace(/\d+/g, '');

const renderFlag = optionValue => {
  if (!optionValue) {
    return '🌐';
  }

  try {
    return getUnicodeFlagIcon(optionValue);
  } catch (_error) {
    return '🌐';
  }
};

export default function PhoneCountrySelect({
  value,
  onChange,
  options,
  disabled,
  readOnly,
  className,
  onFocus,
  onBlur,
  tabIndex,
}) {
  return (
    <SearchableSelect
      value={value}
      onChange={onChange}
      options={options}
      disabled={disabled}
      readOnly={readOnly}
      className={`phone-country-select${className ? ` ${className}` : ''}`}
      onFocus={onFocus}
      onBlur={onBlur}
      tabIndex={tabIndex}
      ariaLabel={`Selected country: ${value || 'Select country'}`}
      onSearchTermChange={sanitizeSearchInput}
      renderOptionPrefix={renderFlag}
      renderTriggerPrefix={renderFlag}
      showSelectedLabel={false}
    />
  );
}
